// Styles for SignatureCarousel go here.
import styled, { keyframes } from 'styled-components';
import { toRem, baseVariables, contextualVariable } from '@marriott/mi-ui-library';

// Define the keyframes
const offsetLeftTablet = keyframes`
  from {
    margin-left: ${toRem(160)};
  }
  to {
    margin-left: ${toRem(16)};
  }
`;

const offsetLeft = keyframes`
  from {
    margin-left: ${toRem(310)};
  }
  to {
    margin-left: ${toRem(24)};
  }
`;

const offsetLeftRemove = keyframes` 
  from {
    margin-left: ${toRem(24)};
  }
  to {
    margin-left: ${toRem(310)};
  }
`;

const offsetLeftTabletRemove = keyframes` 
  from {
    margin-left: ${toRem(16)};
  }
  to {
    margin-left: ${toRem(160)};
  }
`;

const slideInFromRightTablet = keyframes` 
  from {
    left: 100%;
  }
  to {
    left: 50%;
  }
`;

const slideInFromRightMobile = keyframes` 
  from {
    left: 100%;
  }
  to {
    left: calc(50% - ${toRem(135)});
  }
`;

const slideInFromRight = keyframes` 
  from {
    left: 100%;
  }
  to {
    left: 52%;
  }
`;

const slideInFromRightRTL = keyframes` 
  from {
    left: 100%;
  }
  to {
    left: 0;
  }
`;

const slideInFromRightMobileRTL = keyframes` 
  from {
    left: 100%;
  }
  to {
    left: -10%;
  }
`;

const slideInFromLeftTablet = keyframes` 
  from {
    left: -64%;
  }
  to {
    left: 50%;
  }

`;

const slideInFromLeftMobile = keyframes` 
  from {
    left: -64%;
  }
  to {
    left: calc(50% - ${toRem(135)});
  }

`;

const slideInFromLeft = keyframes` 
  from {
    left: -52%;
  }
  to {
    left: 52%;
  }
`;

const slideInFromLeftRTL = keyframes` 
  from {
    left: -25%;
  }
  to {
    left: 0;
  }
`;

const slideInFromLeftMobileRTL = keyframes` 
  from {
    left: -25%;
  }
  to {
    left: -10%;
  }
`;

const awayFromTablet = keyframes` 
  from {
    left: 36%;
  }
  to {
    left: -59%;
  }
`;

const awayFromMobile = keyframes` 
  from {
    left: calc(50% - ${toRem(135)});
  }
  to {
    left: -59%;
  }
`;

const towardsFromTablet = keyframes`
  from {
    left: 50%;
  }
  to {
    left: 59%;
  }
`;

const towardsFromMobile = keyframes`
  from {
    left: calc(50% - ${toRem(135)});
  }
  to {
    left: 59%;
  }
`;

const awayFromVW = keyframes` 
  from {  
    left: 52%;
  }
  to {
    left: -45%;
  }
`;

const awayFromVWRTL = keyframes` 
  from {  
    left: 0%;
  }
  to {
    left: -25%;
  }
`;

const awayFromMobileRTL = keyframes` 
  from {  
    left: -10%;
  }
  to {
    left: -25%;
  }
`;

const towardsFromVW = keyframes` 
  from {
    left: 52%;
  }
  to {
    left: 85%;
  }
`;

const towardsFromVWRTL = keyframes` 
  from {
    left: 0%;
  }
  to {
    left: 25%;
  }
`;

const towardsFromTabletRTL = keyframes` 
  from {
    left: 0%;
  }
  to {
    left: 45%;
  }
`;

const towardsFromMobileRTL = keyframes` 
  from {
    left: -10%;
  }
  to {
    left: 45%;
  }
`;

export const StyledSignatureCarousel = styled.div`
  .image-top {
    @media only ${baseVariables.mediaQuery.md} {
      margin-top: ${toRem(142)};
    }
    @media only ${baseVariables.mediaQuery.lg} {
      margin-top: ${toRem(78)};
    }
  }

  .carouselControlType2 .left-arrow,
  .carouselControlType2 .right-arrow {
    [dir='rtl'] & {
      flex-direction: row-reverse;
      @media only ${baseVariables.mediaQuery.md} {
        margin-left: ${toRem(24)};
        margin-right: ${toRem(24)};
      }
    }
  }

  img {
    margin-left: ${toRem(16)};
    [dir='rtl'] & {
      margin-left: unset;
      margin-right: ${toRem(16)};
    }
    width: ${toRem(283)};
    height: ${toRem(189)};
    @media only ${baseVariables.mediaQuery.md} {
      margin-left: 0;
      width: ${toRem(534)};
      height: ${toRem(346)};
    }
    @media only ${baseVariables.mediaQuery.lg} {
      width: ${toRem(657)};
      height: ${toRem(438)};
    }
  }

  .glide__slide {
    position: relative;
  }

  .slide-desc-content {
    z-index: 2;
    width: ${toRem(284)};
    height: ${toRem(268)};
    text-align: center;
    left: calc(50% - ${toRem(135)});
    margin-top: ${toRem(-48)};
    position: relative;
    border: ${toRem(1)} ${baseVariables.border.borderStyleDefault} ${contextualVariable.accentColor};
    [dir='rtl'] & {
      left: -10%;
    }
    @media only ${baseVariables.mediaQuery.md} {
      position: absolute;
      width: ${toRem(348)};
      margin-top: ${toRem(-96)};
      top: 90.9%;
      left: 50%;
      [dir='rtl'] & {
        left: 0;
      }
    }
    @media only ${baseVariables.mediaQuery.lg} {
      width: ${toRem(464)};
      height: ${toRem(266)};
      top: 78.9%;
      left: 50%;
      [dir='rtl'] & {
        left: 0;
      }
    }
  }

  .slide-in-from-right {
    animation: ${slideInFromRightMobile} 1s forwards;
    animation-timing-function: ease-in;
    [dir='rtl'] & {
      animation: ${slideInFromRightMobileRTL} 1s forwards;
    }
    @media only ${baseVariables.mediaQuery.md} {
      animation: ${slideInFromRightTablet} 1s forwards;
      [dir='rtl'] & {
        animation: ${slideInFromRightRTL} 1s forwards;
      }
    }
    @media only ${baseVariables.mediaQuery.lg} {
      animation: ${slideInFromRight} 1s forwards;
      [dir='rtl'] & {
        animation: ${slideInFromRightRTL} 1s forwards;
      }
    }
  }

  .slide-in-from-left {
    animation: ${slideInFromLeftMobile} 1s forwards;
    animation-timing-function: ease-in;
    [dir='rtl'] & {
      animation: ${slideInFromLeftMobileRTL} 1s forwards;
    }
    @media only ${baseVariables.mediaQuery.md} {
      animation: ${slideInFromLeftTablet} 1s forwards;
      [dir='rtl'] & {
        animation: ${slideInFromLeftRTL} 1s forwards;
      }
    }
    @media only ${baseVariables.mediaQuery.lg} {
      animation: ${slideInFromLeft} 1s forwards;
      [dir='rtl'] & {
        animation: ${slideInFromLeftRTL} 1s forwards;
      }
    }
  }

  .slide-desc-content-position {
    @media only ${baseVariables.mediaQuery.md} {
      top: -13%;
    }
    @media only ${baseVariables.mediaQuery.lg} {
      top: 5%;
    }
  }
  .change-img-offset-prev {
    img {
      @media only ${baseVariables.mediaQuery.md} {
        animation: ${offsetLeftTablet} 1s forwards;
        animation-timing-function: ease-in;
      }

      @media only ${baseVariables.mediaQuery.lg} {
        animation: ${offsetLeft} 1s forwards;
        animation-timing-function: ease-in;
      }
    }
  }
  .change-image-offset {
    img {
      @media only ${baseVariables.mediaQuery.md} {
        animation: ${offsetLeftTabletRemove} 1s forwards;
        animation-timing-function: ease-in;
      }
      @media only ${baseVariables.mediaQuery.lg} {
        animation: ${offsetLeftRemove} 1s forwards;
        animation-timing-function: ease-in;
      }
    }
  }

  .change-desc-right {
    animation: ${awayFromMobile} 1s forwards;
    animation-timing-function: ease-in;
    [dir='rtl'] & {
      animation: ${awayFromMobileRTL} 1s forwards;
    }
    @media only ${baseVariables.mediaQuery.md} {
      animation: ${awayFromTablet} 1s forwards;
      [dir='rtl'] & {
        animation: ${awayFromVWRTL} 1s forwards;
      }
    }
    @media only ${baseVariables.mediaQuery.lg} {
      animation: ${awayFromVW} 1s forwards;
      [dir='rtl'] & {
        animation: ${awayFromVWRTL} 1s forwards;
      }
    }
  }

  .change-desc-left {
    animation: ${towardsFromMobile} 1s forwards;
    animation-timing-function: ease-in;
    [dir='rtl'] & {
      animation: ${towardsFromMobileRTL} 1s forwards;
    }
    @media only ${baseVariables.mediaQuery.md} {
      animation: ${towardsFromTablet} 1s forwards;
      [dir='rtl'] & {
        animation: ${towardsFromTabletRTL} 1s forwards;
      }
    }
    @media only ${baseVariables.mediaQuery.lg} {
      animation: ${towardsFromVW} 1s forwards;
      [dir='rtl'] & {
        animation: ${towardsFromVWRTL} 1s forwards;
      }
    }
  }

  .color-class {
    .left-arrow,
    .right-arrow,
    .left-arrow::after,
    .right-arrow::before {
      color: ${baseVariables.color['base20']};
    }
    .glide__bullet::after {
      background-color: ${baseVariables.color['base20']};
    }
  }

  .right-arrow,
  .left-arrow {
    width: fit-content;
  }
`;
